import { isRolloutFlagEnabled } from '@pequity/shared/utils/rollout-flags';
import { type NavigationGuard } from 'vue-router';
import { MCP_ACCESS_FLAG } from '@/mcp/constants';

export const redirectToHomeIfMcpAccessDisabled: NavigationGuard = () => {
  if (!isRolloutFlagEnabled(MCP_ACCESS_FLAG)) {
    return { name: 'home' };
  }
  return true;
};
